import Vue from 'vue';
import * as Sentry from '@sentry/vue';

export default async (ctx) => {
  const sentryURL = ctx.$config.sentryUrl;
  const environment = ctx.$config.ocusEnvironment;

  const { Replay } = await import('@sentry/replay');

  Sentry.init({
    Vue,
    dsn: sentryURL,
    environment,
    integrations: [
      new Replay({
        sessionSampleRate: 0,
        errorSampleRate: 1.0,
        maskAllText: false,
        blockAllMedia: false,
        networkCaptureBodies: true,
        networkDetailAllowUrls: [window.location.origin, ctx.$config.ocusApiUrl],
      }),
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
  });
};
